import allImgPaths from "assets/images";
import EmailVendorListModal from "components/common/modal/EmailVendorListModal";
import PinModal from "components/common/modal/PinModal";
import ViewContentModal from "components/common/modal/ViewContentModel";
import Tooltip from "components/common/tooltip/Tooltip";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sendEmails } from "services/event";
import { ACTUAL_TASK_NAMES, EMAIL_CATEGORIES, EMAIL_TEMPLATE_CATEGORIES, LOGISTICS_AND_OTHERS_ACTIONS_TABS } from "utils/constant";
import Toast from "components/common/Toast";
import { downloadData } from "services/event";
import saveAs from 'file-saver';
import { updateRAGMessage } from "services/chat";
import useAppState from "context/useAppState";
import LogisticsModal from "components/common/modal/LogisticsModal";

const LogisticsCard = ({ taskId, data: dataObj, deleteItem, actions, setEditorItemIsFavorite, unPinTaskData, callFromBoard }: any) => {
    const [data, setData] = useState(dataObj || null);
    const { id: eventId } = useParams();
    const [showPinModal, setShowPinModal] = useState(false);
    const [showOption, setShowOption] = useState<any>(false);
    const [isPinned, setIsPinned] = useState<boolean>(dataObj?.is_pinned || false)
    const [showViewModal, setShowViewModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);
    const [logisticsTypes, setLogisticsTypes] = useState<any>([])
    const [isFavorite, setIsFavorite] = useState(dataObj?.is_favorite || false)
    const { setState: setEventDataState, sendButtonRef } = useAppState("eventData");
    const { selectedCardDetail } = useAppState('cardWrapper');
    const [defaultLogisticsTab, setDefaultLogisticsTab] = useState(LOGISTICS_AND_OTHERS_ACTIONS_TABS.meeting_spaces)
    const [openLogisticsModal, setOpenLogisticsModal] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false)

    useEffect(() => {
        if (data?.content) {
            const objs = Object.keys(data?.content);
            const actualNames: any = LOGISTICS_AND_OTHERS_ACTIONS_TABS
            const updatedNames: any = []

            if (objs?.length) {
                objs.map((ob: any) => {
                    let name = actualNames[ob];
                    updatedNames.push(name)
                })
                setLogisticsTypes(updatedNames);
            }
        }
    }, [data])

    const handleUserImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfileImage
    }

    const openPinModal = async () => {
        setShowPinModal(true)
    }

    const editItem = () => {
        setIsViewMode(false)
        const allTasks = selectedCardDetail?.tasks;
        const task = allTasks.find((at: any) => at?.title.toLowerCase() == ACTUAL_TASK_NAMES.LOGISTICS_AND_OTHERS.FINALIZE_LOGISTICS.toLowerCase());
        setEventDataState({ currentTaskObj: { task_name: task?.title || null, task_id: task?._id || null } })
        setDefaultLogisticsTab('meeting spaces')
        setOpenLogisticsModal(true)

        setShowOption(false)
    }

    const viewItem = () => {
        setIsViewMode(true)
        const allTasks = selectedCardDetail?.tasks;
        const task = allTasks.find((at: any) => at?.title.toLowerCase() == ACTUAL_TASK_NAMES.LOGISTICS_AND_OTHERS.FINALIZE_LOGISTICS.toLowerCase());
        setEventDataState({ currentTaskObj: { task_name: task?.title || null, task_id: task?._id || null } })
        setDefaultLogisticsTab('meeting spaces')
        setOpenLogisticsModal(true)

        setShowOption(false)
    }

    const setFavorite = async (messageId: any, title: any, value: boolean) => {
        await updateRAGMessage(messageId, { isFavorite: value })
        setIsFavorite(value)
    }

    const afterSave = (value: boolean) => {
        if (value) {
            setIsPinned(true)
        }
    }

    const unPinTaskFromMenu = async () => {
        const payload = {
            isPinned: false,
            pinData: null,
            taskTitle: data?.title || ''
        }

        unPinTaskData(data?.ragId, payload)
        setData(null)
    }

    return (
        <>
            {
                showPinModal &&
                <PinModal
                    draftTitle={data?.title || ''}
                    data={data}
                    setShowPinModal={setShowPinModal}
                    afterSave={afterSave}
                />
            }
            {
                openLogisticsModal &&
                <LogisticsModal
                    isShowModal={openLogisticsModal}
                    defaultTab={defaultLogisticsTab}
                    setOpenLogisticsModal={setOpenLogisticsModal}
                    isViewMode={isViewMode}
                />
            }
            {
                data?.content &&
                <div className='border border-[#EAECF0] px-2 py-2 rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 hover:shadow-xl'>
                    <div className="relative">
                        {/* callfromboard Design */}
                        {
                            callFromBoard &&
                            <div className="rounded-tl-lg rounded-tr-lg border border-dashed border-[#EAECF0] pl-4 pt-1">
                                <h5 className="text-lg text-[#344054] truncate max-w-52 font-interMedium">
                                    {data?.pinData?.title || 'No Title'}
                                </h5>
                                <h6 className="text-sm text-[#344054] pb-2 truncate max-w-52">
                                    {data?.pinData?.selectedOption || 'No Subheading'}
                                </h6>
                            </div>
                        }
                        <div className='h-[190px] rounded-[10px] mb-2.5 group'>
                            <div className='flex items-center justify-between'>
                                {!isPinned &&
                                    <div onClick={openPinModal} className={`group-hover:flex hidden items-center gap-x-1.5 bg-[#1E0AF5] hover:bg-[#120693] py-1.5 px-3 rounded-lg text-[#fff] absolute top-2 right-2 cursor-pointer w-fit`}>
                                        <img src={allImgPaths.pinPushIcon} alt="" />
                                        <span>Pin it</span>
                                    </div>
                                }
                                {
                                    isPinned &&
                                    <div className={`absolute top-2 right-2 w-fit pinned-state`}>
                                        <img src={allImgPaths.pinnedStateIcon} alt="" />
                                    </div>
                                }
                                <img
                                    className={`${callFromBoard ? "rounded-bl-[10px] rounded-br-[10px] " : "rounded-[10px]"} w-full h-full object-cover mb-2`}
                                    src={data?.imageUrl ? data.imageUrl : allImgPaths.ContractPinned}
                                    alt=''
                                />
                            </div>
                        </div>
                        {
                            !callFromBoard &&
                            <h5 className={`mt-1.5 text-[#101828] font-interSemiBold text-[17px] line-clamp-2 max-w-72 px-0.5 mb-3 h-12`}>
                                Logistics Requirements
                            </h5>
                        }
                        {
                            logisticsTypes?.length > 0 &&
                            <div className="flex flex-wrap gap-1.5 mb-1 items-start min-h-[50px]">
                                {
                                    logisticsTypes?.slice(0, 4).map((category: any, categoryIndex: number) => (
                                        <span title={category} key={categoryIndex} className="text-xs font-interSemiBold text-[#363F72] border border-[#D5D9EB] rounded bg-[#F8F9FC] py-0.5 px-1 truncate max-w-[80px]">
                                            {category}
                                        </span>
                                    ))
                                }
                                {
                                    logisticsTypes?.length > 4 &&
                                    <div className="relative group cursor-pointer leading-[1.25]">
                                        <span className="text-xs font-interSemiBold text-[#363F72] border border-[#D5D9EB] rounded bg-[#F8F9FC] py-0.5 px-1">
                                            + {(logisticsTypes.slice(4).length)}
                                        </span>
                                        <Tooltip list={logisticsTypes.slice(4).map((item: any) => ({ _id: item, name: item }))} />
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <div className='flex items-center gap-x-2 justify-between border-t border-[#EAECF0] pt-2 pb-1'>
                        <div className='flex items-start gap-x-2'>
                            <img
                                className='w-6 h-6 rounded-full'
                                src={data.userProfileImage || allImgPaths.defaultProfileImage}
                                alt=''
                                onError={(e: any) => handleUserImageError(e)}
                            />
                            <div>
                                <p className='text-xs text-[#667085] pb-0.5'>{data.userName}</p>
                                <p className='text-xs text-[#667085]'>{data.updatedTime}</p>
                            </div>
                        </div>

                        <div className='flex items-center gap-x-4'>
                            <img
                                onClick={() => setFavorite(data?.messageId, data.title, !isFavorite)}
                                className='w-6 h-6 cursor-pointer on-hover-red'
                                src={
                                    isFavorite ? allImgPaths.heartIconRed : allImgPaths.heartIconGrey
                                }
                                alt=''
                            />
                            <div className="relative group">
                                <img className={`cursor-pointer mr-1`} src={allImgPaths.threeVerticleDotsIcon} alt="" />

                                <div className={`absolute -right-1 -bottom-[10px] w-[188px] rounded-lg shadow-customShadow9 bg-[#fff] px-2 py-2 z-20 border border-[#eee] group-hover:block hidden`}>
                                    {
                                        !callFromBoard && actions?.showDelete && !isPinned &&
                                        <div
                                            className="flex items-center gap-x-2 cursor-pointer w-fit custom-group-hover py-1"
                                            onClick={editItem}>
                                            <img
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.EditIcon2}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                                Edit
                                            </span>
                                        </div>
                                    }
                                    {
                                        callFromBoard &&
                                        <div
                                            className="flex items-center gap-x-1 my-1.5 cursor-pointer w-fit last:mb-0 custom-group-hover" onClick={unPinTaskFromMenu}>
                                            <img
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.deleteIcon4}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none pl-1 group-hover-child-text">
                                                Unpin
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default LogisticsCard;
